import React, { useMemo } from 'react';
import { getDurationFromMilliseconds } from '@ubeya/shared/utils/time';
import styled from 'styled-components';
import { FlexColumn, SmallBody } from '@ubeya/shared-web/components';

const Wrapper = styled(FlexColumn)`
  position: relative;

  > ${SmallBody} {
    font-weight: 500;
  }
`;

const TotalTimeWithoutBreaksRenderer = ({ rowData }) => {
  const { subRows, actualTotalWithoutBreaks } = rowData;

  const actualTotalDuration = useMemo(
    () => (actualTotalWithoutBreaks > 0 ? getDurationFromMilliseconds(actualTotalWithoutBreaks) : ''),
    [actualTotalWithoutBreaks]
  );

  if (subRows && !actualTotalWithoutBreaks) {
    return null;
  }

  return (
    <Wrapper>
      <SmallBody className="actual">
        <span>{actualTotalDuration}</span>
      </SmallBody>
    </Wrapper>
  );
};

export default TotalTimeWithoutBreaksRenderer;
